/**
 *
 *  Share by Social
 *
 *  @module share
 *
 *  Created by Vladimir Shislyannikov on 21/05/2020.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

// Share parameters
var shareTitle;
var shareText;
var shareUrl;

// // Share urls
// var facebookUrl;
// var twitterUrl;
// var emailUrl;

// // Twitter + email parameters
// var twitterUrlParams;
// var emailUrlParams;

var currentUrl;
var currentPageTitle;

// Open Graph data
var ogUrl;
var ogTitle;
var ogDescription;

module.exports = {
  init(...shareParams) {
    currentUrl = window.location.href;
    currentPageTitle = document.title;

    var ogUrlElement = document.querySelector('meta[property="og:url"]');
    var ogTitleElement = document.querySelector('meta[property="og:title"]');
    var ogDescriptionElement = document.querySelector(
      'meta[property="og:description"]'
    );

    if (ogUrlElement && ogTitleElement && ogDescriptionElement) {
      ogUrl = ogUrlElement.getAttribute("content");
      ogTitle = ogTitleElement.getAttribute("content");
      ogDescription = ogDescriptionElement.getAttribute("content");
    }

    this.getParams(...shareParams);
  },

  openFacebookShareWindow() {
    var facebookUrl =
      "https://www.facebook.com/sharer/sharer.php?u=" + shareUrl;

    window.open(facebookUrl, "share-facebook", "width=580,height=296");

    // return false;
  },

  openTwitterShareWindow() {
    var twitterUrl;
    // var shareTitle = '123';
    // var shareText = '';
    // var shareUrl = 'https://trubeapp.com/booking/partners/boxing';
    var twitterUrlParams = shareText
      ? `text=${shareTitle} / ${shareText}&url=${shareUrl}`
      : `text=${shareTitle}&url=${shareUrl}`;

    twitterUrl = `http://twitter.com/share?${twitterUrlParams}`;

    window.open(twitterUrl, "share-twitter", "width=550,height=235");

    // return false;
  },

  openWhatsAppShareWindow() {
    var whatsAppUrl;
    // eslint-disable-next-line no-unused-vars
    var whatsAppUrlParams = shareText
      ? `${shareTitle} / ${shareText}&url=${shareUrl}`
      : `${shareTitle}&url=${shareUrl}`;

    whatsAppUrl =
      "https://api.whatsapp.com/send?text=" + shareText + " " + shareUrl; //whatsAppUrlParams ;

    window.open(whatsAppUrl, "share-wahtsapp", "width=550,height=235");
  },

  openEmailShareWindow(shareText) {
    var emailUrl;
    var emailUrlParams = shareText
      ? `${shareText}%0D%0A%0D%0A${shareUrl}&subject=${shareTitle}`
      : `${shareUrl}&subject=${shareTitle}`;

    emailUrl = "mailto:?&body=" + emailUrlParams;

    window.open(emailUrl, "share-email");

    // return false;
  },

  getParams(title, text, url) {
    // Get the share title, text and url
    // Set fallback values if not defined
    shareTitle = title || currentPageTitle || ogTitle;
    shareText = text || ogDescription || "";
    shareUrl = url || currentUrl || ogUrl;
  },
};
